module.exports = __webpack_public_path__ + "static/media/wind_speed_comparative_per_wtg.62f8a253.svg";